module.exports = __webpack_public_path__ + "img/c6a8af26374a65acdd18442dbef64b96.12a3c042.jpg";